import { useQuery } from 'react-query';

import { handleRequest } from '../../redux/services/APIService';
import {
  buildPhotoGalleryQueryParams,
  GALLERY_API_PATH,
  GALLERY_DEFAULT_PERIOD,
} from '../../containers/Web/PetPhotoGallery/petPhotoGalleryConfig';

export const useGetFacilityPhotoGallery = (
  options = {
    period: GALLERY_DEFAULT_PERIOD,
    singleDayDate: '',
    utcOffset: 0,
  },
) => {
  const {
    period = GALLERY_DEFAULT_PERIOD,
    singleDayDate = '',
    utcOffset = 0,
    ...queryOptions
  } = options;

  const queryParams = buildPhotoGalleryQueryParams({
    period,
    singleDayDate,
    utcOffset,
  });

  return useQuery(
    ['getFacilityPhotoGallery', queryParams],
    async () => {
      const response = await handleRequest(
        'get',
        GALLERY_API_PATH,
        true,
        null,
        queryParams,
      );

      const items = Array.isArray(response?.data?.items)
        ? response.data.items
        : [];

      return { items };
    },
    {
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
      keepPreviousData: true,
      ...queryOptions,
    },
  );
};
